import React from 'react';
import PropTypes from 'prop-types';
import AsyncSelect from 'react-select/async';
import {
  AbstractComponent
} from '../atoms/index';

export default class MustacheSenbeiTag extends AbstractComponent {
  constructor (props) {
    super(props);
    this.state = {
      senbeiTag: {}
    };
    this.fetchOptions = this.fetchOptions.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.props.handleChangeMustacheSenbeiTags({ index: this.props.i }, this.props.i);
  }

  fetchOptions (inputValue) {
    return new Promise((resolve) => {
      const url = `/macaron/api/suggest/senbei_tags?name=${inputValue}`;
      this.fetch(url).then(data => { resolve(data.data); });
    });
  }

  handleChange (value) {
    value.index = this.props.i;
    this.setState({ senbeiTag: value });
    this.props.handleChangeMustacheSenbeiTags(value, this.props.i);
  }

  render () {
    return (
      <div className="mr-4" style={{ width: '100%' }}>
        <AsyncSelect
          loadOptions={this.fetchOptions}
          onChange={this.handleChange}
          value={this.state.senbeiTag}
          defaultInputValue={this.state.senbeiTag.label}
        />
      </div>
    );
  }
}

MustacheSenbeiTag.propTypes = {
  i: PropTypes.number.isRequired,
  handleChangeMustacheSenbeiTags: PropTypes.func.isRequired
};

MustacheSenbeiTag.defaultProps = {
};
